import HeaderSearch from "./source/content-elements/HeaderSearch.js";
export {};
function toggleFirstNavigationLevel(firstLevelLink) {
  if (!!(firstLevelLink.closest(".item--level-1") && firstLevelLink.closest(".item--level-1").querySelector(".mega-menu"))) {
    const firstLevelItem = firstLevelLink.closest(".item--level-1");
    firstLevelItem.classList.toggle("item--open");
    document.querySelectorAll(".item--level-1").forEach(function(sibling) {
      if (!(sibling === firstLevelItem))
        sibling.classList.toggle("hidden");
    });
  }
}
function toggleSecondNavigationLevel(secondLevelLink) {
  if (!!(secondLevelLink.closest(".item--level-2") && secondLevelLink.closest(".item--level-2").querySelector(".column__subitems"))) {
    const secondLevelItem = secondLevelLink.closest(".item--level-2");
    secondLevelItem.classList.toggle("column__item--open");
    document.querySelectorAll(".item--level-2").forEach(function(sibling) {
      if (!(sibling === secondLevelItem))
        sibling.classList.toggle("hidden");
    });
    const megaMenuContainer = secondLevelItem.closest(".mega-menu");
    if (megaMenuContainer) {
      const firstLevelLink = megaMenuContainer.previousElementSibling;
      firstLevelLink?.classList.toggle("hidden");
    }
  }
}
function InitHeader() {
  const burger = document.querySelector(".burger");
  if (burger) {
    const ariaLabelOpen = burger.dataset.arialabelopen;
    const ariaLabelClose = burger.dataset.arialabelclose;
    burger.ariaLabel = ariaLabelOpen;
    burger.addEventListener("click", function() {
      if (burger.classList.toggle("burger--active")) {
        burger.ariaLabel = ariaLabelClose;
        document.querySelector(".nav-container")?.classList.add("nav-container--active");
        document.querySelector("body")?.classList.add("nav-open");
      } else {
        burger.ariaLabel = ariaLabelOpen;
        document.querySelector(".nav-container")?.classList.remove("nav-container--active");
        document.querySelector("body")?.classList.remove("nav-open");
      }
    });
  }
  const firstLevelLinks = document.querySelectorAll(".item--level-1.item--has-children .item__link");
  for (const firstLevelLink of firstLevelLinks) {
    const iconElements = [
      firstLevelLink.parentElement.querySelector(".icon--before"),
      firstLevelLink.parentElement.querySelector(".icon--after")
    ];
    iconElements.forEach((iconElement) => {
      iconElement?.addEventListener("click", function(e) {
        e.preventDefault();
        if (window.innerWidth < 1880) {
          toggleFirstNavigationLevel(firstLevelLink);
        }
      });
    });
  }
  const secondLevelLinks = document.querySelectorAll(".item--level-2.column__item--has-children .mega-menu__item");
  for (const secondLevelLink of secondLevelLinks) {
    const iconElements = [
      secondLevelLink.parentElement.querySelector(".icon--before"),
      secondLevelLink.parentElement.querySelector(".icon--after")
    ];
    iconElements.forEach((iconElement) => {
      iconElement?.addEventListener("click", function(e) {
        e.preventDefault();
        if (window.innerWidth < 1880) {
          toggleSecondNavigationLevel(secondLevelLink);
        }
      });
    });
  }
}
function PreventLineBreaksBetweenNumbersAndUnits() {
  document.querySelectorAll("p").forEach(function(paragraph) {
    paragraph.innerHTML = paragraph.innerHTML.replace(/(\d)\s([^ ])/gm, "$1&nbsp;$2");
  });
}
function InitDesktopSearch() {
  new HeaderSearch().init();
}
function InitDropdownGTM() {
  if (!!document.querySelector("#contact-form-general-23-category")) {
    document.querySelector("#contact-form-general-23-category").addEventListener("change", function(event) {
      const target = event.target;
      window.dataLayer.push({
        event: "select choice",
        eventLabel: target.options[target.selectedIndex].label
      });
    }, false);
  }
}
function InitPlzSection() {
  if (window.location.hash == "#sektion-plz") {
    window.location.hash = "#c45";
  }
}
InitHeader();
PreventLineBreaksBetweenNumbersAndUnits();
InitDesktopSearch();
InitDropdownGTM();
InitPlzSection();
